import { defineComponent as _defineComponent } from 'vue'
import { Workflow } from '@ply-io/ply-front-shared-utilities';
import { useRouter } from 'vue-router/composables';
import EditInstalledWorkflowConfiguration from '@/views/Installables/EditInstalledWorkflowConfiguration.vue';
import { useEmbeddedApp, EmbeddedAppActionTypes } from '../SideBar/embedded-app-entry-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbeddedEditInstalledWorkflowConfiguration',
  props: EditInstalledWorkflowConfiguration.props,
  setup(__props) {

const props = __props

const { push } = useRouter();

const { sendMessage } = useEmbeddedApp();

const close = (workflow: Workflow) => {
	sendMessage({ action: EmbeddedAppActionTypes.Close });
	push({ name: 'InstallationComplete', query: { wfId: workflow.id.toString() } });
};

return { __sfc: true,push, props, sendMessage, close, EditInstalledWorkflowConfiguration }
}

})